<template>
  <div class="choosepeople">
    总人数：{{ checkArray.length}}
    <el-input
      v-model="filterText"
      placeholder="输入关键字进行过滤"/>
    <el-tree
      ref="tree"
      :props="props1"
      :load="loadNode1"
      :filter-node-method="filterNode"
      lazy
      node-key="id"
      show-checkbox
      @check="handleCheckChange"/>
  </div>
</template>
<script>
/* global $UMCore */
/* eslint handle-callback-err: "warn" */
export default {
  name:'UmSelectuser',
  data() {
    return {
      props1: {
        label: 'name'
      },
      flist: [],
      filterText: '',
      icon:'el-icon-success'
    }
  },
  props:["checkArray","total"],
  /**
   * 监听过滤词变化
   */
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    checkArray(val){
      this.$refs.tree.setCheckedNodes(val)
    },
    total(val){
      this.totalPeople=val
    }
  },
  mounted() {
    var that = this
    var arr=[]  
    that.checkArray.forEach(m => {
      // if(m.id!=$UMCore.uncompile('umid')){
        arr.push(m.id)
      // }
    });
    that.$refs.tree.setCheckedKeys(arr);
    var result = {
      __event_name: 'selectors',
      userlist_get_result(ummsg) {
        if (ummsg.data.itype === '0') {
          $UMCore.msg({
            cmd: 'fun',
            op: 'userresult',
            info: '',
            data: { status: true, flist: ummsg.data.slist }
          })
        } else {
          that.flist = ummsg.data.slist
          $UMCore.msg({
            cmd: 'fun',
            op: 'userresult1',
            info: '',
            data: { status: true, flist: ummsg.data.slist }
          })
        }
      }
    }
    $UMCore.on(['fun'], result)

  },
  methods: {
    loadNode1(node, resolve) {
      var that=this
      if (node.level === 0) {
        $UMCore
          .post('route.lua', {
            data: JSON.stringify({
              functionname: 'userlist_get',
              itype: 0,
              umid: $UMCore.uncompile('umid'),
              page: 0,
              pagesize: 5,
              disabled:3
            })
          })
          .then(function(res) {
            if (res.data.status) {
              var arr=res.data.slist
              return resolve(arr)
            }
          })
          .catch(function(error) {})
      }

      if (node.level > 0) {
        if (node.data.type !== '1') {
          $UMCore
            .post('route.lua', {
              data: JSON.stringify({
                functionname: 'userlist_get',
                itype: node.data.itype,
                umid: $UMCore.uncompile('umid'),
                orgid: node.data.orgid,
                deptno: node.data.deptno,
                disabled:3
              })
            })
            .then(function(res) {
              if (res.data.status) {
                var arr=res.data.slist
                var arrq=[]
                that.checkArray.forEach(m => {
                  arrq.push(m.id)
                });
                that.$refs.tree.setCheckedKeys(arrq);
                return resolve(arr)
              }
            })
            .catch(function(error) {})
        } else {
          return resolve([])
        }
      }
    },
    /**
     * 获取选中的node节点
     */
    getCheckedNodes() {
      console.log(this.$refs.tree.getCheckedNodes())
      console.log(this.$refs.tree.getCheckedKeys())
    },
    /**
     * 根据关键词检索列表
     */
    filterNode(value, data, node) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    handleCheckChange(data, checked, indeterminate) {
      var that = this
      var checklist = that.$refs.tree.getCheckedNodes()
      var s = ''
      for (var i = 0; i < checklist.length; i++) {
        if (data.id === checklist[i].id) {
          if (data.type === '1') {
            data.usercount = 1
          }
          s = 'add'
        }
      }
      if (s === 'add') {
        that.totalPeople = that.totalPeople + parseInt(data.usercount)
      } else if (s === '') {
        that.totalPeople = that.totalPeople - parseInt(data.usercount)
      }
      that.$emit('check',data,that.totalPeople)
    }
  }
}
</script>
<style>
.choosepeople{
  height: 100%;
  width: 100%;
  overflow: auto;
}
.choosepeople::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.22);
}
/*定义滚动条高宽及背景*/
.choosepeople::-webkit-scrollbar {
  display: block;
  width: 7px;
  background-color: rgba(144,147,153,.3);
}
/*定义滚动条*/
.choosepeople::-webkit-scrollbar-thumb {
  background-color: #8b8b8b;
  border-radius: 7px;
}
@media (max-width: 750px){
  .choosepeople{
    width: 100%;
    height: 100%;
  }
}
.choosepeople .el-tree>.el-tree-node>.el-tree-node__content>.el-checkbox {
   display: none
}
</style>



// WEBPACK FOOTER //
// src/packages/selectuser/um-selectuser.vue